import React, { useEffect, useState } from "react";
import { authFetch } from "../api";

export default function AdminProfile() {
  const [profile, setProfile] = useState(null);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [pwMessage, setPwMessage] = useState("");
  const [pwError, setPwError] = useState("");

  useEffect(() => {
    authFetch("/core/profile/")
      .then((res) => res.json())
      .then(setProfile)
      .catch(() => setError("Failed to load profile."));
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    try {
      const res = await authFetch("/core/profile/", {
        method: "PATCH",
        body: JSON.stringify({
          email: profile.email,
          first_name: profile.first_name,
          last_name: profile.last_name,
        }),
      });
      if (!res.ok) throw new Error();
      setMessage("Profile updated.");
    } catch {
      setError("Failed to update profile.");
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPwMessage("");
    setPwError("");
    try {
      const res = await authFetch("/core/profile/change-password/", {
        method: "POST",
        body: JSON.stringify({ old_password: oldPassword, new_password: newPassword }),
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.old_password || "Failed to change password.");
      }
      setPwMessage("Password changed.");
      setOldPassword("");
      setNewPassword("");
    } catch (err) {
      setPwError(err.message);
    }
  };

  if (!profile) return <p className="text-gray-400">Loading...</p>;

  const inputClass = "w-full px-4 py-2 rounded-lg bg-white/5 border border-navy-border text-white focus:outline-none focus:border-accent-light";

  return (
    <div className="max-w-xl space-y-10">
      <div>
        <h1 className="text-2xl font-bold mb-6">Profile</h1>
        <form onSubmit={handleSave} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-300 mb-1">Username</label>
            <input value={profile.username} disabled className={`${inputClass} opacity-50`} />
          </div>
          <div>
            <label className="block text-sm text-gray-300 mb-1">Email</label>
            <input
              type="email"
              value={profile.email}
              onChange={(e) => setProfile({ ...profile, email: e.target.value })}
              className={inputClass}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-gray-300 mb-1">First Name</label>
              <input
                value={profile.first_name}
                onChange={(e) => setProfile({ ...profile, first_name: e.target.value })}
                className={inputClass}
              />
            </div>
            <div>
              <label className="block text-sm text-gray-300 mb-1">Last Name</label>
              <input
                value={profile.last_name}
                onChange={(e) => setProfile({ ...profile, last_name: e.target.value })}
                className={inputClass}
              />
            </div>
          </div>
          {message && <p className="text-sm text-green-400">{message}</p>}
          {error && <p className="text-sm text-red-400">{error}</p>}
          <button className="px-6 py-2 rounded-lg bg-brand-gradient text-white font-semibold">
            Save Changes
          </button>
        </form>
      </div>

      <div>
        <h2 className="text-xl font-semibold mb-4">Change Password</h2>
        <form onSubmit={handleChangePassword} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-300 mb-1">Current Password</label>
            <input
              type="password"
              required
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              className={inputClass}
            />
          </div>
          <div>
            <label className="block text-sm text-gray-300 mb-1">New Password</label>
            <input
              type="password"
              required
              minLength={8}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className={inputClass}
            />
          </div>
          {pwMessage && <p className="text-sm text-green-400">{pwMessage}</p>}
          {pwError && <p className="text-sm text-red-400">{pwError}</p>}
          <button className="px-6 py-2 rounded-lg border border-navy-border hover:border-accent-light font-semibold">
            Change Password
          </button>
        </form>
      </div>
    </div>
  );
}
